import { Box, Typography } from "@mui/material";
import { statCardStyles as s } from "../styles/styles";

// Shell for a KPI stat card — icon circle + a header row (label + optional "?"
// tooltip on the left, optional headerRight cluster on the right) + a flexible
// body. `hideIconOnMobile` drops the icon circle on phones to save space.
const StatCard = ({
  icon,
  iconBg,
  label,
  tooltip,
  headerRight,
  children,
  hideIconOnMobile,
}) => (
  <Box sx={s.card}>
    <Box
      sx={{
        ...s.iconBox(iconBg),
        ...(hideIconOnMobile ? { display: { xs: "none", sm: "flex" } } : {}),
      }}
    >
      {icon}
    </Box>
    <Box sx={s.body}>
      <Box sx={s.labelRow}>
        <Box sx={s.labelGroup}>
          <Typography sx={s.label}>{label}</Typography>
          {tooltip}
        </Box>
        {headerRight}
      </Box>
      {children}
    </Box>
  </Box>
);

export default StatCard;
